// Pure helper for the login gate in app.js. When an unauthenticated visitor lands on a
// deep link (newsletter, SMS, shared article), the gate sends them to /welcome. The link
// is remembered as appState.wantedPage so the login flows (routes/login/*.js) can route
// back to it instead of the front page.

// Not worth returning to: the front page itself, the auth screens, logout, and the
// approval/PIN gates the app routes to on its own after login.
const SKIP_RE = /^\/(welcome|login|register|forgotten|logout|waiting-approval|profile\/set-pin)(\/|\?|$)/;

export function isDeepLinkToRemember(url) {
    if (typeof url !== 'string') return false;
    const path = url.trim();
    if (path === '' || path === '/' || path.charAt(0) !== '/') return false;
    return !SKIP_RE.test(path);
}

export default isDeepLinkToRemember;
